import React from "react";
import {
  Box,
  Text,
  Badge,
  Image,
  VStack,
  HStack,
  Flex,
} from "@chakra-ui/react";

const ApiProductSuite = () => {
  const products = [
    {
      icon: "/assets/bankfill.svg",
      name: "Virtual Account Creation",
      api: "Collections API",
      description:
        "Generate static or dynamic virtual accounts for collections and reconciliations. Perfect for marketplaces and platforms.",
      status: "Live",
    },
    {
      icon: "/assets/receipt2.svg",
      name: "Bills Payment",
      api: "Utility API",
      description:
        "Enable airtime, internet, and utility bill payment across all major Nigeria services providers with instant processing.",
      status: "Live",
    },
    {
      icon: "/assets/bank-fill.svg",
      name: "Naira Payout",
      api: "Transfer API",
      description:
        "Disburse funds to any Nigerian bank account with instant processing and competitive fees. Supports bulk transfers.",
      status: "Live",
    },
    {
      icon: "/assets/wallet2.svg",
      name: "Wallet Services",
      api: "Wallet API",
      description:
        "Manage in-app wallets and transfers with full balance management, transaction history, and wallet-to-wallet transfers.",
      status: "Live",
    },
    {
      icon: "/assets/vCard.svg",
      name: "USD Virtual Card",
      api: "Card API",
      description:
        "Enable global USD payments with virtual cards. Perfect for online shopping, subscriptions, and international payments.",
      status: "Live",
    },
    {
      icon: "/assets/dollar2.svg",
      name: "USD Virtual Account",
      api: "FX API",
      description:
        "Receive and hold USD from anywhere in the world. Accept international payments with ease and competitive rates.",
      status: "Live",
    },
    {
      icon: "/assets/payout.svg",
      name: "USD Payout (100+ Countries)",
      api: "International Transfer API",
      description:
        "Send international payments with competitive FX rates to over 100 countries. Fast, secure, and reliable.",
      status: "Live",
    },
  ];

  const StatusIndicator = ({ label }) => (
    <HStack
      spacing="8px"
      align="center"
      bg="#D1FFE2"
      borderRadius="999px"
      px="14px"
      py="6px"
    >
      <Box
        w="16px"
        h="16px"
        borderRadius="50%"
        bg="#10B981"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 4L5.25 8.25L3 6"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>
      <Text fontSize="13px" fontWeight={600} color="#166534">
        {label}
      </Text>
    </HStack>
  );

  return (
    <Box
      bg="#ffffff"
      w="100%"
      py={{ base: "60px", md: "100px" }}
      px={{ base: "20px", md: "80px", lg: "120px" }}
    >
      <VStack spacing="40px" align="center" w="100%">
        {/* Top Section */}
        <VStack spacing="16px" align="center" w="100%" maxW="800px">
          <Badge
            display="flex"
            alignItems="center"
            gap="8px"
            w="fit-content"
            bg="#E0E7FF"
            color="#2463EB"
            px="16px"
            py="6px"
            border="1px solid #2463EB"
            borderRadius="20px"
            fontSize="13px"
            fontWeight={600}
          >
            <Image
              src="/assets/product.svg"
              alt="product-suite"
              w="16px"
              h="16px"
            />
            Product Suite
          </Badge>
          <Text
            fontSize={{ base: "32px", md: "48px" }}
            fontWeight={700}
            textAlign="center"
            color="#0F172B"
          >
            Comprehensive Product Suite
          </Text>
          <Text
            fontSize={{ base: "14px", md: "18px" }}
            textAlign="center"
            color="#64748B"
            maxW="700px"
          >
            Explore BizFlex’s modular API built to power financial innovation.
          </Text>
        </VStack>

        {/* Table Section */}
        <Box
          bg="#fff"
          borderRadius="24px"
          w="100%"
          maxW="1200px"
          boxShadow="0 8px 32px rgba(15, 23, 42, 0.08)"
          overflow="hidden"
        >
          {/* Table Header */}
          <Flex
            bg="#2463EB"
            color="#fff"
            px={{ base: "16px", md: "32px" }}
            py="18px"
            fontWeight={700}
            fontSize={{ base: "14px", md: "16px" }}
          >
            <Box flex={0.35}>API PRODUCT</Box>
            <Box flex={0.5}>DESCRIPTION</Box>
            <Box flex={0.15}>STATUS</Box>
          </Flex>

          {/* Rows */}
          <VStack align="stretch" spacing="0">
            {products.map((product, index) => (
              <Flex
                key={product.name}
                px={{ base: "16px", md: "32px" }}
                py="24px"
                borderTop={index === 0 ? "none" : "1px solid #E2E8F0"}
                bg="#fff"
                flexDir={{ base: "column", md: "row" }}
                gap={{ base: "16px", md: "0" }}
              >
                <HStack flex={0.35} align="flex-start" spacing="12px">
                  <Image
                    src={product.icon}
                    alt={product.name}
                    w="32px"
                    h="32px"
                  />
                  <VStack align="flex-start" spacing="4px">
                    <Text fontWeight={600} color="#0F172B">
                      {product.name}
                    </Text>
                    <Text fontSize="13px" color="#64748B">
                      {product.api}
                    </Text>
                  </VStack>
                </HStack>

                <Box flex={0.5}>
                  <Text fontSize="14px" color="#475569" lineHeight="22px">
                    {product.description}
                  </Text>
                </Box>

                <Flex
                  flex={0.15}
                  justify={{ base: "flex-start", md: "flex-end" }}
                  align="center"
                >
                  <StatusIndicator label={product.status} />
                </Flex>
              </Flex>
            ))}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default ApiProductSuite;


